import { useMutation } from '@tanstack/react-query';
import type {
	LWApiPublicVmWareVCloudVdcLoginUrlParamsRawI,
	LWApiPublicVmWareVCloudVdcLoginUrlResultRawI,
} from '@liquidweb-dev/club-sauce/public/vmWare/vCloud/vDC/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useVmWareVCloudVdcLoginUrl = () => {
	const snackbarError = useSnackbarError('Failed to fetch VMWare login URL');

	return useMutation<
		LWApiPublicVmWareVCloudVdcLoginUrlResultRawI,
		ApiErrorI,
		LWApiPublicVmWareVCloudVdcLoginUrlParamsRawI
	>({
		mutationFn: (params) => api.vmWare.vCloud.vdc.apiRaw.loginUrl(params),

		onError: snackbarError,
	});
};

export default useVmWareVCloudVdcLoginUrl;
